import React from 'react';
import style from "./index.module.css";
import {Button, Table} from "antd";
import {DownloadOutlined} from "@ant-design/icons";

const CertificateCharge = () => {
    const columns: any[] = [
        {
            title: '序号',
            dataIndex: 'id',
            key: 'id',
            width: '10%',
            align: 'center',
        },
        {
            title: '收费项目',
            dataIndex: 'name',
            key: 'name',
            width: '20%',
            align: 'center',
        },
        {
            title: '收费标准',
            dataIndex: 'standard',
            key: 'standard',
            width: '50%',
            align: 'center',
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: '20%',
            align: 'center',
        },
    ];

    const data = [
        {
            id: 1,
            name: "申请费",
            standard: "(15000元+每增加一个认证单元增5000元）×核定系数",
            remark: "费用按照核定系数后的费用",
        },
        {
            id: 2,
            name: "检查费",
            standard: "5000元/人日×人日数",
            remark: "",
        },
        {
            id: 3,
            name: "检验检测费",
            standard: "按检验机构收费标准",
            remark: "适用时",
        },
        {
            id: 4,
            name: "审定与注册费(含证书费)",
            standard: "5000元/单元×产品单元数×核定系数",
            remark: "",
        },
        {
            id: 5,
            name: "年金(含标志使用)",
            standard: "5000元/单元×产品单元数×核定系数",
            remark: "",
        },
        {
            id: 6,
            name: "认证差旅费",
            standard: "参照《中央和国家机关差旅费管理办法》（财行〔2013〕531号））和《中央和国家机关工作人员赴地方差旅住宿费标准明细表》（财行〔2016〕71号）等有关规定收取",
            remark: "具体事宜双方协商而定",
        },
        {
            id: 7,
            name: "证书变更费",
            standard: "500元/单元",
            remark: "",
        },
        {
            id: 8,
            name: "证书打印费",
            standard: "500元/单元",
            remark: "",
        },
    ]

    return (
        <div>
            <div className={style.articleTitle}>
                产品认证收费标准
            </div>

            <div>
                <p>
                    根据国家发展计划委员会和国家质量技术监督局《关于印发产品质量认证收费管理办法和收费标准的通知》[计价格（1999）1610号]的规定并参照国际惯例制定两山认证产品认证收费标准：
                </p>

                <div style={{margin: "10px 5%", width: "90%"}}>
                    <Table style={{
                        backgroundColor: '#eeeeee',  // 设置表格背景颜色
                        color: '#333',                // 设置字体颜色
                        textAlign: 'center',            // 设置文本对齐方式
                    }}  size="small" rowClassName={style.row} pagination={false}  columns={columns}
                           dataSource={data}/>
                </div>

                <p>
                    说明：
                    <p> 1.申请费在初评/复评/扩项时收取，一次申请超过一个产品单元时，每增加一个单元，增加5000元；并根据产品的结构复杂程度、产品成熟度和风险程度等核算核定系数；扩项时按收费标准的50%收取申请费；
                    </p>
                    <p>2.检查总人日数按认证委托人的生产场所、生产规模、生产过程以及认证模式确定，并根据申请认证产品的技术难度、产品单元数量、产品之间差异性程度等因素核算；
                    </p>
                    <p>3.人日数包括文件评审、检查组前期准备、现场检查和最终报告的时间，不包括路途时间；
                    </p>
                    <p>4.认证监督和认证复评时的检查人日数可在初次认证基础上酌情减少。
                    </p>
                    <p>5.认证变更时根据变更涉及的具体工作决定具体收费项目；对于申请人名称和/或地址变更（不包含搬迁）、商标的变更、由于命名方法变化引起的单元名称或型号表述的变更等情况，只收取证书变更费500元/张。
                    </p>

                </p>

            </div>
        </div>
    );
};

export default CertificateCharge;